import { render, staticRenderFns } from "./ServciePage.vue?vue&type=template&id=92653a16&scoped=true&"
import script from "./ServciePage.vue?vue&type=script&lang=js&"
export * from "./ServciePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92653a16",
  null
  
)

export default component.exports